module.exports = __webpack_public_path__ + "static/media/services.d1a5d21b.svg";